import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card } from "@/components/PortalPage";

const when = (s) => new Date(s).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const NotificationBell = () => {
  const [d, setD] = useState({ rows: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const load = () => api("/billing/notifications").then(setD).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const readAll = async () => { await api("/billing/notifications/read", { method: "POST", body: { all: true } }); load(); };
  const readOne = (id) => api("/billing/notifications/read", { method: "POST", body: { ids: [id] } }).then(load).catch(() => {});
  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)} data-testid="notif-bell" aria-label="Notifications" className="relative flex h-10 w-10 items-center justify-center rounded-[10px] border border-[#333] transition-colors hover:border-[var(--accent)]">
        <Bell size={18} />{d.unread > 0 && <span className="absolute -right-1.5 -top-1.5 rounded-full bg-[#EF4444] px-1.5 text-[10px] font-extrabold text-white" data-testid="notif-unread">{d.unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 z-30 mt-2 w-[340px] rounded-[14px] border border-[#333] bg-[#141414] p-3 shadow-2xl" data-testid="notif-panel">
          <div className="mb-2 flex items-center justify-between"><p className="text-xs font-extrabold tracking-[1.5px] text-neutral-400">NOTIFICATIONS</p>{d.unread > 0 && <button onClick={readAll} className="text-[11px] font-bold text-[var(--accent)]" data-testid="notif-read-all">Mark all read</button>}</div>
          {!d.rows.length && <p className="py-4 text-center text-xs text-[#777]" data-testid="notif-empty">Nothing yet.</p>}
          <div className="max-h-[380px] space-y-1.5 overflow-y-auto">
            {d.rows.map((n) => (
              <Link key={n.id} to={n.link || "/billing"} onClick={() => { setOpen(false); readOne(n.id); }} data-testid={`notif-${n.id}`}
                className={`block rounded-lg p-2 text-[12px] transition-colors hover:bg-[#1E1E1E] ${n.read_at ? "text-[#A0A0A0]" : "bg-[#1A1A1A] text-white"}`}>
                <b>{n.title}</b><span className="block text-[11px] text-[#888]">{n.body} · {when(n.created_at)}</span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export const NotifyPrefs = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api("/billing/notify-prefs").then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const set = async (k, ch, v) => {
    const prefs = { ...d.prefs, [k]: { ...d.prefs[k], [ch]: v } };
    setD({ ...d, prefs });
    try { await api("/billing/notify-prefs", { method: "PUT", body: { prefs } }); toast.success("Saved"); } catch (e) { toast.error(e.message); }
  };
  return (
    <Card className="space-y-2" data-testid="notify-prefs-card">
      <p className="text-xs font-bold tracking-[2px] text-[var(--accent)]">NOTIFICATIONS</p>
      <p className="text-xs text-[#A0A0A0]">Choose what alerts you in ALR Ops and by email. You get each alert once, and at most one "viewed" alert per quote version per day.</p>
      <div className="grid grid-cols-[1fr_auto_auto] items-center gap-x-4 gap-y-2 text-sm">
        <span /><span className="text-[10px] font-bold text-[#888]">IN APP</span><span className="text-[10px] font-bold text-[#888]">EMAIL</span>
        {Object.entries(d.labels).map(([k, label]) => (
          <div key={k} className="contents">
            <span>{label}</span>
            <input type="checkbox" checked={d.prefs[k].in_app} onChange={(e) => set(k, "in_app", e.target.checked)} data-testid={`pref-${k}-in-app`} className="h-4 w-4 accent-[#4CCC06]" />
            <input type="checkbox" checked={d.prefs[k].email} onChange={(e) => set(k, "email", e.target.checked)} data-testid={`pref-${k}-email`} className="h-4 w-4 accent-[#4CCC06]" />
          </div>
        ))}
      </div>
      <p className="text-[11px] text-[#777]">Text message alerts aren't set up yet.</p>
    </Card>
  );
};
